var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"editor",staticClass:"editor",attrs:{"contenteditable":"true"},on:{"input":_vm.input}})])
}
var staticRenderFns = []

export { render, staticRenderFns }